import styled from 'styled-components';
import { hexToRgba } from '../../../../utils/style';

import { NewStyleColor } from '../../../../utils/styles-constants';

const PageTitle = styled('div')`
	padding: 10px 0 5px 10px;
	font-size: 13px;
	line-height: 20px;
	color: ${hexToRgba(NewStyleColor.White, 75)};
`;

const PageInput = styled('input')`
	width: 50px!important;
	padding: 10px!important;
`;

const RadioButtons = styled('div')`
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	white-space: nowrap;
	width: 100%;
	max-width: 100%;
	min-width: 0;
	margin-bottom: -15px;

	> label {
		display: inline-flex;
		flex-wrap: nowrap;
		align-items: center;
		margin-bottom: 15px;
		white-space: nowrap;
	}
`;

export {
	PageTitle,
	PageInput,
	RadioButtons,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/EditPanel/LinkPanel/styles.ts